const url = (vendor?: Vendor.Raw): string => {
	const urls = vendor?.siteUrls;
	if (urls?.length) {
		return urls.find((current) => current.siteId === 90)?.relativeUri || '';
	}
	return '';
};

export default url;
